'use client'

import React, { useState } from 'react'
import { StandardCard, StandardCardProps } from './index'
import FavouriteButton from '../../FavouriteButton'
import { FavouriteContextProvider } from '@/context/favouriteContext'

export interface StandardClientCardProps extends StandardCardProps {
  initialFavorite?: boolean
  onFavoriteClick?: () => void
}

export const StandardClientCard: React.FC<StandardClientCardProps> = ({
  initialFavorite = false,
  onFavoriteClick,
  ...props
}) => {
  //const [isFavorite, setIsFavorite] = useState<boolean>(initialFavorite)

  /*const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault() // Prevent the link from navigating when clicking the favorite button
    setIsFavorite((prev) => !prev)
    onFavoriteClick?.()
  }*/

  return (
    <div className={props.className}>
      <div className="relative h-full">
        <StandardCard
          {...props}
          className="!m-0 h-full" // or your styling overrides
        />
        {/* The favorite button */}
        <FavouriteContextProvider
          collection={props.collection || null}
          itemId={props.favItemId || ''}
          path={(props as { href?: string | null }).href || undefined}
          title={props.title}
        >
          <FavouriteButton
            initialFavorite={initialFavorite}
            showBackground={true}
            hasImage={!!props.image}
          />
        </FavouriteContextProvider>
      </div>
    </div>
  )
}
